import { render, staticRenderFns } from "./TgMobileGameSD.vue?vue&type=template&id=4c6e3924&"
import script from "./TgMobileGameSD.vue?vue&type=script&lang=js&"
export * from "./TgMobileGameSD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports